import { Link } from 'react-router-dom';
import { Clock, ArrowRight } from 'lucide-react';
import { CATEGORY_META, ACCENTS } from '../../lib/academyApi';

export const ArticleCard = ({ article }) => {
  const meta = CATEGORY_META[article.category] || { name: article.category, accent: 'orange' };
  const accent = ACCENTS[meta.accent] || ACCENTS.orange;

  return (
    <Link
      to={`/academy/${article.slug}`}
      className="group relative flex flex-col rounded-2xl overflow-hidden bg-[#161618] border border-zinc-800/80 hover:border-zinc-700 transition-all duration-300 hover:-translate-y-1"
      data-testid={`article-card-${article.slug}`}
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        <img
          src={article.heroImage}
          alt={article.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#161618] via-transparent to-transparent" />
        <span
          className={`absolute top-3 left-3 text-[11px] font-semibold uppercase tracking-wide px-2.5 py-1 rounded-full border backdrop-blur-md ${accent.chip}`}
        >
          {meta.name}
        </span>
      </div>

      <div className="flex flex-col flex-1 p-5">
        <div className="flex items-center gap-2 text-xs text-zinc-500 mb-2">
          <Clock className="w-3.5 h-3.5" />
          {article.readingTime} min read
        </div>
        <h3
          className="text-lg font-bold text-white leading-snug group-hover:text-orange-400 transition-colors"
          style={{ fontFamily: 'Space Grotesk' }}
        >
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-zinc-400 leading-relaxed line-clamp-2 flex-1">
          {article.excerpt}
        </p>
        <span className={`mt-4 inline-flex items-center gap-1.5 text-sm font-semibold ${accent.text}`}>
          Read Article
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
};

export default ArticleCard;
